import type { Anamnesis, Evaluation, Patient, PatientSummary, TimelineItem } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export interface PatientRecords {
  anamneses: { id: string; status: 'draft' | 'signed'; createdAt: string; redFlags: string[] }[];
  evaluations: { id: string; status: 'draft' | 'signed'; createdAt: string }[];
}

export const patientsQuery = (q: string) => queryOptions({
  queryKey: ['patients', 'list', q], queryFn: () => api<PatientSummary[]>(`/patients${q ? `?q=${encodeURIComponent(q)}` : ''}`),
  placeholderData: (prev) => prev,
});
export const patientQuery = (id: string) => queryOptions({ queryKey: ['patients', id], queryFn: () => api<Patient>(`/patients/${id}`) });
export const timelineQuery = (id: string) => queryOptions({ queryKey: ['patients', id, 'timeline'], queryFn: () => api<TimelineItem[]>(`/patients/${id}/timeline`) });
export const recordsQuery = (id: string) => queryOptions({ queryKey: ['patients', id, 'records'], queryFn: () => api<PatientRecords>(`/patients/${id}/records`) });
export const anamnesisQuery = (id: string) => queryOptions({ queryKey: ['anamneses', id], queryFn: () => api<Anamnesis>(`/anamneses/${id}`) });
export const evaluationQuery = (id: string) => queryOptions({ queryKey: ['evaluations', id], queryFn: () => api<Evaluation>(`/evaluations/${id}`) });
export const patientByContactQuery = (contactId: string) => queryOptions({
  queryKey: ['patients', 'by-contact', contactId], queryFn: () => api<{ patientId: string | null }>(`/contacts/${contactId}/patient`),
});

export const SEX_LABELS: Record<string, string> = { female: 'Feminino', male: 'Masculino', intersex: 'Intersexo', not_informed: 'Prefere não informar' };
export const formatDate = (iso: string) => new Date(`${iso}T12:00:00`).toLocaleDateString('pt-BR');
export const when = (iso: string) => new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
export const day = (iso: string) => new Date(iso).toLocaleDateString('pt-BR');
